export function updateCart(detail) {
  const event = new CustomEvent('updateCart', { detail });
  document.dispatchEvent(event);
}
